/**
 * useIsMobile — returns true when viewport width is < 768px (below Tailwind md).
 *
 * SSR-safe: returns false when window is unavailable.
 * Subscribes to matchMedia change events and updates state on resize.
 */
import { useState, useEffect } from 'react';

const MOBILE_QUERY = '(max-width: 767px)';

function getIsMobile(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(MOBILE_QUERY).matches;
}

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(getIsMobile);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;

    const mql: MediaQueryList = window.matchMedia(MOBILE_QUERY);

    function handleChange(): void {
      setIsMobile(mql.matches);
    }

    mql.addEventListener('change', handleChange);

    return () => {
      mql.removeEventListener('change', handleChange);
    };
  }, []);

  return isMobile;
}
